<template >
 <v-dialog v-model="show_dialog" :max-width="width">
  <v-card>
    <v-card-title>
        <h2>费用支出</h2>
    </v-card-title>
    <v-card-text>
      <v-form>
          <v-text-field
            label="支出金额"
            v-model="money"
            :error = "parseFloat(money)!=money"
            required></v-text-field>
          <v-select
            :items="what_option"
            :error = "!forwhat"
            v-model="forwhat"
            label="用途"
            item-value="value"
            item-text="text"
            no-data-text="请选择用途"
            required
            clearable
          ></v-select>
         <v-select
            :items="from_option"
            :error = "!forwhat"
            v-model="from"
            label="支付方式"
            item-value="value"
            item-text="text"
            no-data-text="请选择支付方式"
            required
            clearable
          ></v-select>
          <v-select
            v-model="bywho"
            :error = "!bywho"
            v-bind:items="sysuser"
            label="经手人"
            item-value="_id"
            item-text="name"
            no-data-text="无可选择的人员"
            required
            clearable
          ></v-select>
          <v-textarea
              v-model="note"
              label="备注"
              rows="2"
            ></v-textarea>
      </v-form>
    </v-card-text>
    
    <v-card-actions>
        <v-spacer></v-spacer>
      <v-btn class="btn-" @click.stop="init_value();show_dialog=false">取消</v-btn>
      <v-btn
          :loading="creating"
          :disabled="creating||!(money*1&&forwhat&&from&&note&&bywho)"
          color="info"
          @click.native.stop="create_record"> 确定
          <span slot="loader" class="custom-loader">
            Loading...
          </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>       
        
   
</template>

<script>
import {base_api} from "@/api/base_api"   
import {selectoption} from "@/api/module/select_options"    
export default {
    //template:``,
    name: '',
    props:{
        width:{
            type:String,
            default:'500px'
        }
    },
    computed:{
        show_dialog:{
          get(){
              return this.$store.state.dialog.show_pay_order_dialog;
          },
          set(val){
              this.$store.commit('SHOW_DIALOG_PAY_ORDER',val)
          }
        }
    },
    methods:{
        init_value(){
            this.money  =  this.bywho  = this.forwhat  = this.note = this.from= null;
        },
        isvalide(){
            return (1*this.money && this.forwhat && this.from && this.note && this.bywho)
        },
        get_user_list(){
            console.log("NEED GET SYSUSER LIST");
            selectoption({oper:'sysuser',key:"_id",value:"name",type:'obj'}).then(resp=>{
                this.sysuser= resp.data;
            }).catch(err=>{
                console.log(err);
            })
        },
        create_record(){
            console.log("click")
            this.creating = true;
            
            if(this.isvalide()){
                base_api({
                    schema:'payout',
                    method:'post',
                    params:{},
                    data:{
                        bywho    :this.bywho,
                        money    :this.money,
                        order_id :this.order_id,
                        forwhat  :this.forwhat,
                        from     :this.from,
                        note     :this.note
                    }
                }).then(doc=>{
                    this.$notify({
                        group: 'msg',
                        type: 'success',
                        title: '操作成功！',
                        text: '提现记录创建成功',
                        duration: 500,
                    })
                    this.show_dialog = false;
                    this.init_value();
                }).catch(err=>{
                    this.$notify({
                        group: 'msg',
                        type: 'warn',
                        title: '操作失败！',
                        text: '提现记录创建失败'+err.message
                    })
                }).then(_=>{
                    debugger;
                    this.creating = false;
                })
            }
        }
    },
    components:{},
    watch:{
        show_dialog(val){
            if(val){
                // this.creating = false,
                this.order_id = + new Date();
                if(this.sysuser.length == 0){
                    this.get_user_list();
                }
            }
        }
    },
    directives: {},
    mounted :function(){
        if(this.sysuser.length == 0){
            this.get_user_list()
        }
    },
    data () {
      return {
        creating :false,
        order_id :+ new Date(),
        money    :null,
        forwhat  :null,
        bywho    :null,
        note     :null,
        from     :null,
        sysuser  :[],
        from_option:[
            {value:'zhuanzhang',text:'转账支出'},
            {value:'liushui',text:'店内流水'},
            {value:'dianfu' ,text:'个人垫付'},
            {value:'onpay' ,text:'记帐'}],
        what_option:[
            {value:'shuidian',text:'水电费'},
            {value:'dianhua',text:'电话费'},
            {value:'wuliu',text:'快递/物流'},
            {value:'fangzu',text:'房租'},
            {value:'qita',text:'其他'}]
        }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_pay_order.vue